import type { User as SupabaseUser } from '@supabase/supabase-js';
import { parseUserId, type UserId } from '@/schemas/ids';

/**
 * Maps a Supabase user ID to our UserId type (ULID brand)
 * Supabase uses UUIDs, so we'll use the UUID string directly as a UserId
 */
export function getUserIdFromSupabaseUser(user: SupabaseUser): UserId {
  // Supabase user.id is already a string (UUID), we'll parse it as UserId
  // Note: UserId is a ULID brand, but for Supabase users we'll use their UUID
  return parseUserId(user.id);
}
